exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#container[data-v-4a866a66] {\n  height: 100%;\n}", ""]);

// exports
